import React from 'react';
import { useWeather } from '../../context';
import { Calendar } from 'lucide-react';

export function DateRangeSelector() {
  const { startDate, endDate, setStartDate, setEndDate, modelSelect } = useWeather();

  // Show for all models
  return (
    <div className="mb-6 space-y-4">
      <div>
        <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
          <Calendar className="w-4 h-4 inline mr-2" />
          Start Date
        </label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="input w-full"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
          <Calendar className="w-4 h-4 inline mr-2" />
          End Date
        </label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="input w-full"
        />
      </div>
    </div>
  );
}